/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserClaimAddDto
 */
export interface UserClaimAddDto {
    /**
     * 
     * @type {string}
     * @memberof UserClaimAddDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimAddDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimAddDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimAddDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UserClaimAddDto interface.
 */
export function instanceOfUserClaimAddDto(value: object): value is UserClaimAddDto {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UserClaimAddDtoFromJSON(json: any): UserClaimAddDto {
    return UserClaimAddDtoFromJSONTyped(json, false);
}

export function UserClaimAddDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClaimAddDto {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'type': json['type'],
        'value': json['value'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UserClaimAddDtoToJSON(json: any): UserClaimAddDto {
    return UserClaimAddDtoToJSONTyped(json, false);
}

export function UserClaimAddDtoToJSONTyped(value?: UserClaimAddDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'type': value['type'],
        'value': value['value'],
        'description': value['description'],
    };
}

